import { useEffect } from "react";
import { useMembers } from "../../hooks/UseMembers";
import { EditMember } from "../members/EditMember";
import { EmptyMember } from "../members/EmptyMember";
import { useSerialVoiceActors } from "../../hooks/UseSerialVoiceActors";

export function EditSerialVoiceActors(props) {
    const user = props.user;
    const serialId = props.serialId;
    const membersHook = useMembers();
    const serialVoiceActorsHook = useSerialVoiceActors();

    useEffect(() => {
        membersHook.loadMembers(user.token, true);
    }, [user]);

    useEffect(() => {
        if (serialId)
            serialVoiceActorsHook.loadSerialVoiceActors(user.token, serialId);
    }, [user, serialId]);

    const onSaveClicked = async (data) => {
        await serialVoiceActorsHook.createSerialVoiceActor(user.token, serialId, data.memberId);
    };

    const onDeleteClicked = async (memberId) => {
        await serialVoiceActorsHook.deleteSerialVoiceActor(user.token, serialId, memberId);
    };

    const allMembers = membersHook.members || [];
    const currentVoiceActors = serialVoiceActorsHook.serialVoiceActors || [];

    if (membersHook.loading || serialVoiceActorsHook.loading) {
        return <div style={{ textAlign: 'center', padding: '10px', color: '#6b7280' }}>Завантаження...</div>;
    }

    const availableMembers = allMembers
        .filter(member => !currentVoiceActors.some(va => va.memberId === member.id))
        .sort((a, b) => (a.nickName || "").localeCompare(b.nickName || ""));

    const memberElements = currentVoiceActors.map(va => {
        const fullMemberData = allMembers.find(m => m.id === va.memberId);

        return (
            <EditMember
                member={va.member || fullMemberData || { nickName: 'ID: ' + va.memberId, id: va.memberId }}
                key={va.id || va.memberId}
                onDeleteClicked={() => onDeleteClicked(va.memberId)}
            />
        );
    });

    return (
        <div style={{ width: '100%' }}>
            {/* New actor */}
            <div style={{ marginBottom: '15px' }}>
                <EmptyMember
                    members={availableMembers}
                    onSaveClicked={onSaveClicked}
                />
            </div>

            {/* Container for list of added actors */}
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px',
                minHeight: '40px',
                padding: '10px',
                backgroundColor: '#f9fafb',
                borderRadius: '8px',
                border: '1px solid #f3f4f6'
            }}>
                {memberElements.length > 0 ? (
                    memberElements
                ) : (
                    <span style={{ color: '#9ca3af', fontSize: '13px' }}>Акторів не додано</span>
                )}
            </div>
        </div>
    );
}